// "Inquiry Details Viewing List List"
// This name is technically correct. No changes necessary.
// It just sounds weird =))

import { Component, h } from 'preact';

import { Inquiry, ViewingListMetadata } from '../../../../../types/inquiries';
import { formatAsColloquialDate } from '../../../../core/date-formatter';
import { hopplerApi } from '../../../../../constants';
import { ReqState } from '../../../../../types';
import { InquiryLoadingMessage, InquiryLoadFailureMessage } from './loaders';

interface InquiryDetailsVlListProps {
  inquiry: Inquiry;
  vlMetaList: ViewingListMetadata[];
  reqState: ReqState;

  onEditClick: (vlKey: string) => void;
}

export class InquiryDetailsVlList extends Component<InquiryDetailsVlListProps> {
  openShareSheet() {
    const inquiry = this.props.inquiry;
    const link = `${location.origin}/vl/${inquiry.inquiryKey}`;

    // At the time of writing, our typings aren't aware of the share functions
    // so we need to work around that.
    // API docs: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
    const nav = navigator as any;

    // Safari's share prioritizes `text` over `url` -- don't add a `text`
    // See here: https://adactio.com/journal/15972
    nav.share({
      title: `Viewing List for ${inquiry.inquiryCode}`,
      url: link
    });
  }

  getShareLink(vlMeta: ViewingListMetadata) {
    const inquiry = this.props.inquiry;
    const link = `${location.origin}/vl/${inquiry.inquiryKey}/${vlMeta.vlKey}`;
    const nav = navigator as any;

    if (nav.share) {
      return (
        <button className="btn btn-link hi-inqdetdoclist__button" onClick={ () => this.openShareSheet() }>
          share
        </button>
      );
    } else {
      return (
        <a className="btn btn-link hi-inqdetdoclist__button"
          href={ link }
          target='_blank' rel='noopener'>
          share
        </a>
      );
    }
  }

  getDownloadLink(vlMeta: ViewingListMetadata) {
    const inquiry = this.props.inquiry;
    const link = `${hopplerApi.host}/kumita/inquiry/${inquiry.inquiryCode}/viewing-lists/${vlMeta.vlKey}/download`;

    return (
      <a className="btn btn-link hi-inqdetdoclist__button"
        href={ link }
        target='_blank' rel='noopener'>
        download
      </a>
    );
  }

  getViewingListItems(props: InquiryDetailsVlListProps) {
    const vlMetaList = props.vlMetaList;

    if (vlMetaList && vlMetaList.length > 0) {
      return vlMetaList.map(vlMeta => (
        <div className="hi-inqdetdoclist__item">
          <div className="hi-inqdetdoclist__loi-row">
            <button className="hi-inqdetdoclist__document-name" onClick={ () => this.props.onEditClick(vlMeta.vlKey) }>
              { vlMeta.name }
            </button>
            
            <div className="hi-inqdetdoclist__buttons">
              { this.getShareLink(vlMeta) }
              { this.getDownloadLink(vlMeta) }
            </div>
          </div>
        </div>
      ))
    }
  }

  render(props: InquiryDetailsVlListProps) {
    if (props.reqState === ReqState.IN_PROGRESS) {
      return <InquiryLoadingMessage message='Loading viewing lists...' />;
    } else if (props.reqState === ReqState.FAILED) {
      return <InquiryLoadFailureMessage message='Could not load viewing lists' />;
    }

    return (
      // We intentionally reuse the document list CSS, because this bit is
      // completely identically styled.
      <div className="hi-inqdetdoclist">
        { this.getViewingListItems(props) }
      </div>
    )
  }
}
